import React, { useState, useEffect } from 'react';
import axios from 'axios';

const Transfers = () => {
  const [transfers, setTransfers] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [clients, setClients] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [showSecretCode, setShowSecretCode] = useState(false);
  const [newSecretCode, setNewSecretCode] = useState('');
  const [newTransfer, setNewTransfer] = useState(null);
  const [editTransfer, setEditTransfer] = useState(null);
  const [loading, setLoading] = useState(false);
  const [senderType, setSenderType] = useState('walk_in');
  const [receiverType, setReceiverType] = useState('walk_in');
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterCurrency, setFilterCurrency] = useState('all');
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [form, setForm] = useState({
    sender_id: null,
    receiver_customer_id: null,
    receiver_name: '',
    receiver_phone: '',
    send_amount: '',
    send_currency: 'IQD',
    receive_currency: 'USD',
    commission_percent: '',
    notes: '',
    assigned_client_id: ''
  });
  const [preview, setPreview] = useState(null);
  const token = localStorage.getItem('token');
  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const isAdmin = user.role === 'owner' || user.role === 'admin';

  const currencyList = [
    { code: 'USD', name: 'دولار أمريكي' },
    { code: 'IQD', name: 'دينار عراقي' },
    { code: 'EUR', name: 'يورو' },
    { code: 'GBP', name: 'جنيه إسترليني' },
    { code: 'SAR', name: 'ريال سعودي' },
    { code: 'AED', name: 'درهم إماراتي' },
    { code: 'TRY', name: 'ليرة تركية' },
    { code: 'CAD', name: 'دولار كندي' },
  ];

  useEffect(() => {
    fetchTransfers();
    fetchCustomers();
    fetchCurrencies();
    fetchClients();
  }, []);

  useEffect(() => {
    calculatePreview();
  }, [form.send_amount, form.send_currency, form.receive_currency, form.commission_percent, currencies]);

  const fetchTransfers = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/transfers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setTransfers(response.data.transfers);
    } catch (err) { console.error(err); }
  };

  const fetchCustomers = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/customers', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomers(response.data.customers);
    } catch (err) { console.error(err); }
  };

  const fetchClients = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/clients', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setClients(response.data.clients);
    } catch (err) { console.error(err); }
  };

  const fetchCurrencies = async () => {
    try {
      const response = await axios.get('https://app.hayahost.net/api/exchange/currencies', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCurrencies(response.data.currencies);
    } catch (err) { console.error(err); }
  };

  const calculatePreview = () => {
    if (!form.send_amount || form.send_amount <= 0) { setPreview(null); return; }
    const amount = parseFloat(form.send_amount);
    const commissionPercent = parseFloat(form.commission_percent || 0);
    const commissionAmount = (amount * commissionPercent) / 100;
    const totalFromSender = amount + commissionAmount;
    let receiveAmount = amount;
    let rate = 1;
    if (form.send_currency !== form.receive_currency) {
      if (form.send_currency === 'IQD') {
        const currency = currencies.find(c => c.code === form.receive_currency);
        if (currency) { rate = parseFloat(currency.sell_rate); receiveAmount = amount / rate; }
      } else if (form.receive_currency === 'IQD') {
        const currency = currencies.find(c => c.code === form.send_currency);
        if (currency) { rate = parseFloat(currency.buy_rate); receiveAmount = amount * rate; }
      } else {
        const sendCur = currencies.find(c => c.code === form.send_currency);
        const recvCur = currencies.find(c => c.code === form.receive_currency);
        if (sendCur && recvCur) {
          const inIQD = amount * parseFloat(sendCur.buy_rate);
          receiveAmount = inIQD / parseFloat(recvCur.sell_rate);
          rate = parseFloat(sendCur.buy_rate);
        }
      }
    }
    setPreview({ sendAmount: amount, sendCurrency: form.send_currency, receiveAmount: receiveAmount.toFixed(2), receiveCurrency: form.receive_currency, commissionPercent, commissionAmount: commissionAmount.toFixed(2), totalFromSender: totalFromSender.toFixed(2), rate });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const commissionAmount = preview ? parseFloat(preview.commissionAmount) : 0;

      // إذا المستلم عميل في النظام، نأخذ اسمه تلقائياً
      let receiverName = form.receiver_name;
      let receiverPhone = form.receiver_phone;
      if (receiverType === 'customer' && form.receiver_customer_id) {
        const receiverCustomer = customers.find(c => c.id == form.receiver_customer_id);
        if (receiverCustomer) {
          receiverName = receiverCustomer.name;
          receiverPhone = receiverCustomer.phone;
        }
      }

      const data = {
        customer_id: senderType === 'customer' ? form.sender_id : null,
        receiver_customer_id: receiverType === 'customer' ? form.receiver_customer_id : null,
        sender_name: senderType === 'walk_in' ? form.sender_name : '',
        sender_phone: senderType === 'walk_in' ? form.sender_phone : '',
        receiver_name: receiverName,
        receiver_phone: receiverPhone,
        amount: form.send_amount,
        currency: form.send_currency,
        receive_amount: preview ? preview.receiveAmount : form.send_amount,
        receive_currency: form.receive_currency,
        fee: commissionAmount,
        commission_percent: form.commission_percent || 0,
        notes: form.notes,
        assigned_client_id: form.assigned_client_id || null,
        sender_type: senderType,
        receiver_type: receiverType
      };

      const response = await axios.post('https://app.hayahost.net/api/transfers', data, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setNewSecretCode(response.data.secret_code);
      setNewTransfer(response.data.transfer);
      setShowSecretCode(true);
      setShowForm(false);
      setForm({ sender_id: null, receiver_customer_id: null, receiver_name: '', receiver_phone: '', send_amount: '', send_currency: 'IQD', receive_currency: 'USD', commission_percent: '', notes: '', assigned_client_id: '' });
      setSenderType('walk_in');
      setReceiverType('walk_in');
      setPreview(null);
      fetchTransfers();
    } catch (err) { alert('خطأ في إرسال الحوالة: ' + (err.response?.data?.message || '')); }
    setLoading(false);
  };

  const updateStatus = async (id, status) => {
    try {
      await axios.put(`https://app.hayahost.net/api/transfers/${id}/status`, { status }, { headers: { Authorization: `Bearer ${token}` } });
      fetchTransfers();
    } catch (err) { console.error(err); }
  };

  const handleEdit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(`https://app.hayahost.net/api/transfers/${editTransfer.id}/status`, { status: editTransfer.status }, { headers: { Authorization: `Bearer ${token}` } });
      setShowEditForm(false);
      fetchTransfers();
      alert('تم التعديل بنجاح!');
    } catch (err) { console.error(err); }
  };

  const filteredTransfers = transfers.filter(t => {
    if (filterStatus !== 'all' && t.status !== filterStatus) return false;
    if (filterCurrency !== 'all' && t.currency !== filterCurrency) return false;
    if (fromDate && new Date(t.created_at) < new Date(fromDate)) return false;
    if (toDate && new Date(t.created_at) > new Date(toDate + 'T23:59:59')) return false;
    if (search) {
      const s = search.toLowerCase();
      return (
        t.reference_number?.toLowerCase().includes(s) ||
        t.sender_name?.toLowerCase().includes(s) ||
        t.receiver_name?.toLowerCase().includes(s) ||
        t.receiver_phone?.includes(s) ||
        t.secret_code?.toLowerCase().includes(s) ||
        t.notes?.toLowerCase().includes(s) ||
        t.currency?.toLowerCase().includes(s)
      );
    }
    return true;
  });

  const totalsByCurrency = filteredTransfers.reduce((acc, t) => {
    if (!acc[t.currency]) acc[t.currency] = { total: 0, fees: 0 };
    acc[t.currency].total += parseFloat(t.amount);
    acc[t.currency].fees += parseFloat(t.fee || 0);
    return acc;
  }, {});

  const totalFees = transfers.reduce((sum, t) => sum + parseFloat(t.fee || 0), 0);
  const completedCount = transfers.filter(t => t.status === 'completed').length;
  const pendingCount = transfers.filter(t => t.status === 'pending').length;

  const getStatusColor = (status) => {
    switch(status) {
      case 'completed': return { background: '#e8f5e9', color: '#2e7d32' };
      case 'pending': return { background: '#fff3e0', color: '#e65100' };
      case 'cancelled': return { background: '#ffebee', color: '#c62828' };
      default: return { background: '#f5f5f5', color: '#666' };
    }
  };

  const getStatusText = (status) => {
    switch(status) {
      case 'completed': return '✅ مكتملة';
      case 'pending': return '⏳ معلقة';
      case 'cancelled': return '❌ ملغاة';
      default: return status;
    }
  };

  const formatDateTime = (dateStr) => {
    if (!dateStr) return '-';
    const d = new Date(dateStr);
    return `${d.toLocaleDateString('ar-IQ')} ${d.toLocaleTimeString('ar-IQ', {hour: '2-digit', minute: '2-digit'})}`;
  };

  const handlePrintCode = () => {
    const printWindow = window.open('', '_blank');
    printWindow.document.write(`
      <html dir="rtl"><head><meta charset="UTF-8"><title>كود الحوالة</title>
      <style>
        body { font-family: Arial, sans-serif; direction: rtl; padding: 30px; text-align: center; }
        .code-box { border: 3px solid #1a237e; border-radius: 15px; padding: 30px; max-width: 400px; margin: 0 auto; }
        .title { color: #1a237e; font-size: 20px; margin-bottom: 10px; }
        .code { font-size: 40px; font-weight: bold; color: #c62828; letter-spacing: 5px; margin: 20px 0; background: #f5f5f5; padding: 15px; border-radius: 10px; }
        .info { font-size: 14px; color: #666; margin: 5px 0; }
        .warning { color: #e65100; font-size: 13px; margin-top: 15px; border-top: 1px solid #e0e0e0; padding-top: 10px; }
      </style></head><body>
      <div class="code-box">
        <div class="title">🏦 نظام الحوالات والصيرفة</div>
        <div class="info">الرقم المرجعي: ${newTransfer?.reference_number}</div>
        <div class="info">المستلم: ${newTransfer?.receiver_name}</div>
        <div class="info">المبلغ: ${parseFloat(newTransfer?.amount || 0).toLocaleString()} ${newTransfer?.currency}</div>
        <div class="code">${newSecretCode}</div>
        <div class="info">الكود السري للاستلام</div>
        <div class="warning">⚠️ احتفظ بهذا الكود وأعطه للمستلم فقط</div>
        <div class="info" style="margin-top:10px;font-size:12px">${formatDateTime(new Date().toISOString())}</div>
      </div>
      </body></html>
    `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div style={styles.container}>
      <div style={styles.navbar}>
        <h1 style={styles.navTitle}>🏦 نظام الحوالات والصيرفة</h1>
        <button style={styles.logoutBtn} onClick={() => { localStorage.clear(); window.location.href = '/login'; }}>خروج</button>
      </div>

      <div style={styles.layout}>
        <div style={styles.sidebar}>
          <a href="/" style={styles.sideItem}>🏠 الرئيسية</a>
          <a href="/customers" style={styles.sideItem}>👥 العملاء</a>
          <a href="/transfers" style={{...styles.sideItem, background: '#e3f2fd', color: '#1a237e', fontWeight: 'bold'}}>💸 الحوالات</a>
          <a href="/exchange" style={styles.sideItem}>💱 الصرافة</a>
          <a href="/debts" style={styles.sideItem}>📋 المديونيات</a>
          <a href="/treasury" style={styles.sideItem}>🏛️ القاصة</a>
          <a href="/accounts" style={styles.sideItem}>📒 حسابات العملاء</a>
          <a href="/clients" style={styles.sideItem}>🔐 إدارة الفروع</a>
          <a href="/reports" style={styles.sideItem}>📊 التقارير</a>
        </div>

        <div style={styles.content}>

          {/* نافذة الكود السري */}
          {showSecretCode && newSecretCode && (
            <div style={styles.modalOverlay}>
              <div style={styles.modal}>
                <h3 style={styles.modalTitle}>✅ تم إنشاء الحوالة بنجاح!</h3>
                <div style={styles.secretCodeBox}>
                  <div style={styles.secretCodeLabel}>🔐 الكود السري للمستلم</div>
                  <div style={styles.secretCode}>{newSecretCode}</div>
                  <div style={styles.secretCodeNote}>⚠️ أعطِ هذا الكود للمستلم فقط</div>
                </div>
                {newTransfer && (
                  <div style={styles.modalDetails}>
                    <div style={styles.modalRow}>
                      <span style={styles.modalLabel}>الرقم المرجعي</span>
                      <span style={styles.modalValue}>{newTransfer.reference_number}</span>
                    </div>
                    <div style={styles.modalRow}>
                      <span style={styles.modalLabel}>المستلم</span>
                      <span style={styles.modalValue}>{newTransfer.receiver_name}</span>
                    </div>
                    <div style={styles.modalRow}>
                      <span style={styles.modalLabel}>المبلغ</span>
                      <span style={{...styles.modalValue, color: '#1a237e', fontSize: '18px', fontWeight: 'bold'}}>
                        {parseFloat(newTransfer.amount).toLocaleString()} {newTransfer.currency}
                      </span>
                    </div>
                  </div>
                )}
                <div style={styles.modalButtons}>
                  <button style={styles.printCodeBtn} onClick={handlePrintCode}>🖨️ طباعة الكود</button>
                  <button style={styles.closeBtn} onClick={() => { setShowSecretCode(false); setNewSecretCode(''); setNewTransfer(null); }}>إغلاق</button>
                </div>
              </div>
            </div>
          )}

          {/* الإحصائيات */}
          <div style={styles.statsGrid}>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1a237e, #0d47a1)'}}>
              <div style={styles.statIcon}>💸</div>
              <div style={styles.statNumber}>{transfers.length}</div>
              <div style={styles.statLabel}>إجمالي الحوالات</div>
            </div>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #1b5e20, #2e7d32)'}}>
              <div style={styles.statIcon}>💰</div>
              <div style={styles.statNumber}>{totalFees.toFixed(2)}</div>
              <div style={styles.statLabel}>إجمالي العمولات</div>
            </div>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #2e7d32, #388e3c)'}}>
              <div style={styles.statIcon}>✅</div>
              <div style={styles.statNumber}>{completedCount}</div>
              <div style={styles.statLabel}>مكتملة</div>
            </div>
            <div style={{...styles.statCard, background: 'linear-gradient(135deg, #e65100, #f57c00)'}}>
              <div style={styles.statIcon}>⏳</div>
              <div style={styles.statNumber}>{pendingCount}</div>
              <div style={styles.statLabel}>معلقة</div>
            </div>
          </div>

          {Object.keys(totalsByCurrency).length > 0 && (
            <div style={styles.currencyTotals}>
              {Object.entries(totalsByCurrency).map(([currency, data]) => (
                <div key={currency} style={styles.currencyTotal}>
                  <span style={styles.ctCurrency}>{currency}</span>
                  <span style={styles.ctTotal}>إجمالي: {data.total.toLocaleString()}</span>
                  <span style={styles.ctFee}>عمولات: {data.fees.toFixed(2)}</span>
                </div>
              ))}
            </div>
          )}

          <div style={styles.header}>
            <h2 style={styles.pageTitle}>💸 إدارة الحوالات</h2>
            <button style={styles.addBtn} onClick={() => setShowForm(!showForm)}>
              {showForm ? 'إلغاء' : '+ حوالة جديدة'}
            </button>
          </div>

          {/* البحث والفلاتر */}
          <div style={styles.searchCard}>
            <div style={styles.searchRow}>
              <input style={styles.searchInput} value={search}
                onChange={e => setSearch(e.target.value)}
                placeholder="🔍 بحث برقم مرجعي، كود سري، اسم مرسل، مستلم، هاتف..." />
              <button style={styles.clearBtn} onClick={() => { setSearch(''); setFilterStatus('all'); setFilterCurrency('all'); setFromDate(''); setToDate(''); }}>
                مسح
              </button>
            </div>
            <div style={styles.filtersRow}>
              <div style={styles.filterGroup}>
                <label style={styles.filterLabel}>الحالة</label>
                <select style={styles.filterSelect} value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
                  <option value="all">الكل</option>
                  <option value="pending">⏳ معلقة</option>
                  <option value="completed">✅ مكتملة</option>
                  <option value="cancelled">❌ ملغاة</option>
                </select>
              </div>
              <div style={styles.filterGroup}>
                <label style={styles.filterLabel}>العملة</label>
                <select style={styles.filterSelect} value={filterCurrency} onChange={e => setFilterCurrency(e.target.value)}>
                  <option value="all">الكل</option>
                  {currencyList.map(c => <option key={c.code} value={c.code}>{c.code}</option>)}
                </select>
              </div>
              <div style={styles.filterGroup}>
                <label style={styles.filterLabel}>من تاريخ</label>
                <input style={styles.filterDate} type="date" value={fromDate} onChange={e => setFromDate(e.target.value)} />
              </div>
              <div style={styles.filterGroup}>
                <label style={styles.filterLabel}>إلى تاريخ</label>
                <input style={styles.filterDate} type="date" value={toDate} onChange={e => setToDate(e.target.value)} />
              </div>
              <div style={styles.filterResult}>
                <span style={styles.filterResultText}>النتائج: <strong>{filteredTransfers.length}</strong> من {transfers.length}</span>
              </div>
            </div>
          </div>

          {/* نموذج إضافة حوالة */}
          {showForm && (
            <div style={styles.formCard}>
              <h3 style={styles.formTitle}>إرسال حوالة جديدة</h3>

              {/* نوع المرسل */}
              <div style={styles.sectionLabel}>👤 المرسل</div>
              <div style={styles.senderTypeRow}>
                <button type="button" style={senderType === 'walk_in' ? styles.typeActive : styles.typeInactive} onClick={() => setSenderType('walk_in')}>🚶 شخص عادي</button>
                <button type="button" style={senderType === 'customer' ? styles.typeActive : styles.typeInactive} onClick={() => setSenderType('customer')}>👤 عميل في النظام</button>
              </div>

              {/* نوع المستلم */}
              <div style={styles.sectionLabel}>🎯 المستلم</div>
              <div style={styles.senderTypeRow}>
                <button type="button" style={receiverType === 'walk_in' ? styles.typeActive : styles.typeInactive} onClick={() => setReceiverType('walk_in')}>🚶 شخص عادي</button>
                <button type="button" style={receiverType === 'customer' ? styles.typeActive : styles.typeInactive} onClick={() => setReceiverType('customer')}>👤 عميل في النظام</button>
              </div>

              {/* معلومات الحوالة */}
              <form onSubmit={handleSubmit}>
                <div style={styles.formGrid}>

                  {/* المرسل */}
                  {senderType === 'customer' ? (
                    <div style={{...styles.inputGroup, }}>
                      <label style={styles.label}>اختر المرسل (عميل في النظام)</label>
                      <select style={styles.input} value={form.sender_id} onChange={e => setForm({...form, sender_id: e.target.value})} required>
                        <option value="">-- اختر المرسل --</option>
                        {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                      </select>
                    </div>
                  ) : (
                    <>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>اسم المرسل</label>
                        <input style={styles.input} value={form.sender_name || ''} onChange={e => setForm({...form, sender_name: e.target.value})} placeholder="اسم المرسل (اختياري)" />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>هاتف المرسل</label>
                        <input style={styles.input} value={form.sender_phone || ''} onChange={e => setForm({...form, sender_phone: e.target.value})} placeholder="هاتف المرسل (اختياري)" />
                      </div>
                    </>
                  )}

                  {/* المستلم */}
                  {receiverType === 'customer' ? (
                    <div style={{...styles.inputGroup, }}>
                      <label style={styles.label}>اختر المستلم (عميل في النظام)</label>
                      <select style={styles.input} value={form.receiver_customer_id} onChange={e => setForm({...form, receiver_customer_id: e.target.value})} required>
                        <option value="">-- اختر المستلم --</option>
                        {customers.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
                      </select>
                    </div>
                  ) : (
                    <>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>اسم المستلم *</label>
                        <input style={styles.input} value={form.receiver_name} onChange={e => setForm({...form, receiver_name: e.target.value})} placeholder="اسم المستلم" required />
                      </div>
                      <div style={styles.inputGroup}>
                        <label style={styles.label}>هاتف المستلم *</label>
                        <input style={styles.input} value={form.receiver_phone} onChange={e => setForm({...form, receiver_phone: e.target.value})} placeholder="07XXXXXXXXX" required />
                      </div>
                    </>
                  )}

                  <div style={styles.inputGroup}>
                    <label style={styles.label}>💵 استلمت من الزبون</label>
                    <div style={styles.amountRow}>
                      <input style={{...styles.input, flex: 1}} type="number" value={form.send_amount} onChange={e => setForm({...form, send_amount: e.target.value})} placeholder="0" required />
                      <select style={{...styles.input, width: '120px'}} value={form.send_currency} onChange={e => setForm({...form, send_currency: e.target.value})}>
                        {currencyList.map(c => <option key={c.code} value={c.code}>{c.code}</option>)}
                      </select>
                    </div>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>🏦 يستلم الزبون</label>
                    <div style={styles.amountRow}>
                      <input style={{...styles.input, flex: 1, background: '#f5f5f5'}} type="text" value={preview ? preview.receiveAmount : ''} readOnly placeholder="تلقائي" />
                      <select style={{...styles.input, width: '120px'}} value={form.receive_currency} onChange={e => setForm({...form, receive_currency: e.target.value})}>
                        {currencyList.map(c => <option key={c.code} value={c.code}>{c.code}</option>)}
                      </select>
                    </div>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>العمولة %</label>
                    <input style={styles.input} type="number" step="0.1" value={form.commission_percent} onChange={e => setForm({...form, commission_percent: e.target.value})} placeholder="مثال: 0.5" />
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>🔐 الفرع المسلِّم</label>
                    <select style={styles.input} value={form.assigned_client_id} onChange={e => setForm({...form, assigned_client_id: e.target.value})}>
                      <option value="">-- اختر الفرع (اختياري) --</option>
                      {clients.map(c => (
                        <option key={c.id} value={c.id}>
                          {c.customer_type === 'company' ? '🏢' : '👤'} {c.customer_name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>ملاحظات</label>
                    <input style={styles.input} value={form.notes} onChange={e => setForm({...form, notes: e.target.value})} placeholder="أي ملاحظات" />
                  </div>
                </div>

                {/* تنبيه للمرسل العميل */}
                {senderType === 'customer' && (
                  <div style={styles.infoBox}>
                    <span>💡 المرسل عميل في النظام:</span>
                    <span>إذا لديه رصيد كافٍ → ينقص من رصيده</span>
                    <span>إذا ليس لديه رصيد → يصبح مديوناً للمكتب</span>
                    <span>القاصة تزيد بالعمولة فقط</span>
                  </div>
                )}

                {/* تنبيه للمستلم العميل */}
                {receiverType === 'customer' && (
                  <div style={{...styles.infoBox, background: '#e8f5e9', borderColor: '#2e7d32'}}>
                    <span>💡 المستلم عميل في النظام:</span>
                    <span>إذا مديون → ينقص من دينه تلقائياً</span>
                    <span>إذا غير مديون → يزيد رصيده لدى المكتب</span>
                  </div>
                )}

                {preview && (
                  <div style={styles.previewCard}>
                    <h4 style={styles.previewTitle}>📊 ملخص الحوالة</h4>
                    <div style={styles.previewGrid}>
                      <div style={styles.previewItem}>
                        <span style={styles.previewLabel}>استلمت من الزبون</span>
                        <span style={styles.previewValue}>{parseFloat(preview.sendAmount).toLocaleString()} {preview.sendCurrency}</span>
                      </div>
                      <div style={styles.previewItem}>
                        <span style={styles.previewLabel}>يستلم الزبون</span>
                        <span style={{...styles.previewValue, color: '#2e7d32'}}>{parseFloat(preview.receiveAmount).toLocaleString()} {preview.receiveCurrency}</span>
                      </div>
                      <div style={styles.previewItem}>
                        <span style={styles.previewLabel}>العمولة ({preview.commissionPercent}%)</span>
                        <span style={{...styles.previewValue, color: '#e65100'}}>{parseFloat(preview.commissionAmount).toLocaleString()} {preview.sendCurrency}</span>
                      </div>
                      <div style={styles.previewItem}>
                        <span style={styles.previewLabel}>الإجمالي من الزبون</span>
                        <span style={{...styles.previewValue, color: '#1a237e', fontSize: '18px'}}>{parseFloat(preview.totalFromSender).toLocaleString()} {preview.sendCurrency}</span>
                      </div>
                    </div>
                  </div>
                )}
                <button style={styles.submitBtn} type="submit" disabled={loading}>
                  {loading ? 'جاري الإرسال...' : '💸 إرسال الحوالة'}
                </button>
              </form>
            </div>
          )}

          {/* نموذج التعديل */}
          {showEditForm && editTransfer && isAdmin && (
            <div style={styles.editCard}>
              <h3 style={styles.formTitle}>✏️ تعديل الحوالة - {editTransfer.reference_number}</h3>
              <form onSubmit={handleEdit}>
                <div style={styles.formGrid}>
                  <div style={styles.inputGroup}>
                    <label style={styles.label}>الحالة</label>
                    <select style={styles.input} value={editTransfer.status} onChange={e => setEditTransfer({...editTransfer, status: e.target.value})}>
                      <option value="pending">⏳ معلقة</option>
                      <option value="completed">✅ مكتملة</option>
                      <option value="cancelled">❌ ملغاة</option>
                    </select>
                  </div>
                </div>
                <div style={{display: 'flex', gap: '10px'}}>
                  <button style={styles.submitBtn} type="submit">حفظ التعديل</button>
                  <button style={styles.cancelEditBtn} type="button" onClick={() => setShowEditForm(false)}>إلغاء</button>
                </div>
              </form>
            </div>
          )}

          {/* الجدول */}
          <div style={styles.tableCard}>
            <table style={styles.table}>
              <thead>
                <tr style={styles.tableHead}>
                  <th style={styles.th}>الرقم المرجعي</th>
                  <th style={styles.th}>الكود السري</th>
                  <th style={styles.th}>المرسل</th>
                  <th style={styles.th}>المستلم</th>
                  <th style={styles.th}>المبلغ</th>
                  <th style={styles.th}>العمولة</th>
                  <th style={styles.th}>الفرع المسلِّم</th>
                  <th style={styles.th}>الحالة</th>
                  <th style={styles.th}>التاريخ</th>
                  <th style={styles.th}>إجراء</th>
                </tr>
              </thead>
              <tbody>
                {filteredTransfers.map((t, i) => (
                  <tr key={t.id} style={i % 2 === 0 ? styles.trEven : styles.trOdd}>
                    <td style={{...styles.td, fontWeight: 'bold', color: '#1a237e', fontSize: '11px'}}>{t.reference_number}</td>
                    <td style={styles.td}>
                      <span style={styles.secretCodeBadge}>{t.secret_code || '-'}</span>
                    </td>
                    <td style={styles.td}>
                      {t.customer_name ? (
                        <span style={{color: '#1a237e', fontWeight: 'bold'}}>👤 {t.customer_name}</span>
                      ) : (
                        <span>{t.sender_name || '🚶 عابر'}</span>
                      )}
                    </td>
                    <td style={styles.td}>
                      {t.receiver_customer_name ? (
                        <span style={{color: '#2e7d32', fontWeight: 'bold'}}>👤 {t.receiver_customer_name}</span>
                      ) : (
                        <>
                          {t.receiver_name}
                          <br/><span style={{fontSize:'11px', color:'#666'}}>{t.receiver_phone}</span>
                        </>
                      )}
                    </td>
                    <td style={styles.td}>{parseFloat(t.amount).toLocaleString()} {t.currency}</td>
                    <td style={{...styles.td, color: '#e65100', fontWeight: 'bold'}}>{parseFloat(t.fee || 0).toFixed(2)}</td>
                    <td style={styles.td}>
                      {t.assigned_customer_name ? (
                        <span style={{color: '#2e7d32', fontSize: '12px', fontWeight: 'bold'}}>
                          🔐 {t.assigned_customer_name}
                        </span>
                      ) : '-'}
                    </td>
                    <td style={styles.td}>
                      <span style={{...getStatusColor(t.status), padding: '4px 10px', borderRadius: '20px', fontSize: '11px'}}>
                        {getStatusText(t.status)}
                      </span>
                      {t.delivered_at && (
                        <div style={{fontSize: '10px', color: '#2e7d32', marginTop: '3px'}}>
                          سُلِّم: {formatDateTime(t.delivered_at)}
                        </div>
                      )}
                    </td>
                    <td style={{...styles.td, fontSize: '11px', color: '#666'}}>{formatDateTime(t.created_at)}</td>
                    <td style={styles.td}>
                      <div style={{display: 'flex', gap: '4px', flexWrap: 'wrap'}}>
                        {t.status === 'pending' && (
                          <>
                            <button style={styles.completeBtn} onClick={() => updateStatus(t.id, 'completed')}>✅</button>
                            <button style={styles.cancelBtnSmall} onClick={() => updateStatus(t.id, 'cancelled')}>❌</button>
                          </>
                        )}
                        {isAdmin && (
                          <button style={styles.editBtn} onClick={() => { setEditTransfer(t); setShowEditForm(true); }}>✏️</button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr style={styles.totalRow}>
                  <td style={styles.totalTd} colSpan="5"><strong>الإجمالي ({filteredTransfers.length} حوالة)</strong></td>
                  <td style={{...styles.totalTd, color: '#e65100'}}><strong>{filteredTransfers.reduce((s,t) => s + parseFloat(t.fee||0), 0).toFixed(2)}</strong></td>
                  <td style={styles.totalTd} colSpan="4"></td>
                </tr>
              </tfoot>
            </table>
            {filteredTransfers.length === 0 && <div style={styles.empty}>لا توجد نتائج</div>}
          </div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  container: { minHeight: '100vh', background: '#f5f5f5' },
  navbar: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', padding: '15px 30px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  navTitle: { color: 'white', fontSize: '20px' },
  logoutBtn: { background: 'rgba(255,255,255,0.2)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', cursor: 'pointer' },
  layout: { display: 'flex' },
  sidebar: { width: '200px', background: 'white', minHeight: 'calc(100vh - 60px)', padding: '20px 0', boxShadow: '2px 0 5px rgba(0,0,0,0.1)' },
  sideItem: { display: 'block', padding: '12px 20px', color: '#333', textDecoration: 'none', fontSize: '14px', borderBottom: '1px solid #f0f0f0' },
  content: { flex: 1, padding: '30px' },
  statsGrid: { display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '15px', marginBottom: '20px' },
  statCard: { borderRadius: '12px', padding: '20px', color: 'white', textAlign: 'center' },
  statIcon: { fontSize: '24px', marginBottom: '8px' },
  statNumber: { fontSize: '28px', fontWeight: 'bold', marginBottom: '5px' },
  statLabel: { fontSize: '12px', opacity: 0.9 },
  currencyTotals: { display: 'flex', gap: '10px', marginBottom: '20px', flexWrap: 'wrap' },
  currencyTotal: { background: 'white', borderRadius: '10px', padding: '12px 20px', display: 'flex', flexDirection: 'column', gap: '4px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
  ctCurrency: { fontSize: '18px', fontWeight: 'bold', color: '#1a237e' },
  ctTotal: { fontSize: '13px', color: '#333' },
  ctFee: { fontSize: '13px', color: '#e65100', fontWeight: 'bold' },
  header: { display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' },
  pageTitle: { color: '#1a237e', fontSize: '22px' },
  addBtn: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '10px 20px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  searchCard: { background: 'white', borderRadius: '12px', padding: '20px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  searchRow: { display: 'flex', gap: '10px', marginBottom: '15px' },
  searchInput: { flex: 1, padding: '10px 15px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl' },
  clearBtn: { background: '#666', color: 'white', border: 'none', padding: '10px 15px', borderRadius: '8px', cursor: 'pointer', fontSize: '13px' },
  filtersRow: { display: 'flex', gap: '15px', alignItems: 'flex-end', flexWrap: 'wrap' },
  filterGroup: { display: 'flex', flexDirection: 'column', gap: '4px' },
  filterLabel: { fontSize: '12px', color: '#666', fontWeight: 'bold' },
  filterSelect: { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterDate: { padding: '8px 12px', border: '1px solid #e0e0e0', borderRadius: '6px', fontSize: '13px' },
  filterResult: { display: 'flex', alignItems: 'center' },
  filterResultText: { fontSize: '13px', color: '#666' },
  formCard: { background: 'white', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  editCard: { background: '#fff8e1', borderRadius: '12px', padding: '25px', marginBottom: '20px', boxShadow: '0 2px 10px rgba(0,0,0,0.1)', border: '2px solid #ffd54f' },
  formTitle: { marginBottom: '15px', color: '#1a237e' },
  sectionLabel: { fontSize: '14px', fontWeight: 'bold', color: '#333', marginBottom: '8px', marginTop: '15px' },
  senderTypeRow: { display: 'flex', gap: '10px', marginBottom: '15px' },
  typeActive: { flex: 1, padding: '12px', background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  typeInactive: { flex: 1, padding: '12px', background: '#f5f5f5', color: '#666', border: '2px solid #e0e0e0', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  formGrid: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginBottom: '20px' },
  inputGroup: {},
  amountRow: { display: 'flex', gap: '8px' },
  label: { display: 'block', marginBottom: '6px', color: '#333', fontSize: '14px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', border: '2px solid #e0e0e0', borderRadius: '8px', fontSize: '14px', direction: 'rtl', boxSizing: 'border-box' },
  infoBox: { background: '#fff3e0', border: '1px solid #e65100', borderRadius: '8px', padding: '12px', marginBottom: '15px', display: 'flex', flexDirection: 'column', gap: '4px', fontSize: '13px', color: '#e65100' },
  previewCard: { background: 'linear-gradient(135deg, #e3f2fd, #bbdefb)', borderRadius: '12px', padding: '20px', marginBottom: '20px', border: '2px solid #1a237e' },
  previewTitle: { color: '#1a237e', marginBottom: '15px', fontSize: '16px' },
  previewGrid: { display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '15px' },
  previewItem: { display: 'flex', flexDirection: 'column', gap: '4px' },
  previewLabel: { fontSize: '12px', color: '#666' },
  previewValue: { fontSize: '16px', fontWeight: 'bold', color: '#333' },
  submitBtn: { background: 'linear-gradient(135deg, #1b5e20, #2e7d32)', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  cancelEditBtn: { background: '#666', color: 'white', border: 'none', padding: '12px 30px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
  tableCard: { background: 'white', borderRadius: '12px', overflow: 'hidden', boxShadow: '0 2px 10px rgba(0,0,0,0.1)' },
  table: { width: '100%', borderCollapse: 'collapse' },
  tableHead: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)' },
  th: { padding: '12px 15px', color: 'white', textAlign: 'right', fontSize: '12px' },
  trEven: { background: 'white' },
  trOdd: { background: '#f8f9fa' },
  td: { padding: '10px 15px', fontSize: '13px', borderBottom: '1px solid #f0f0f0' },
  totalRow: { background: '#e3f2fd' },
  totalTd: { padding: '12px 15px', fontSize: '13px', color: '#1a237e' },
  completeBtn: { background: '#2e7d32', color: 'white', border: 'none', padding: '5px 8px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  cancelBtnSmall: { background: '#c62828', color: 'white', border: 'none', padding: '5px 8px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  editBtn: { background: '#e65100', color: 'white', border: 'none', padding: '5px 8px', borderRadius: '6px', cursor: 'pointer', fontSize: '13px' },
  empty: { textAlign: 'center', padding: '40px', color: '#999' },
  secretCodeBadge: { background: '#fff3e0', color: '#e65100', padding: '4px 10px', borderRadius: '10px', fontSize: '12px', fontWeight: 'bold', letterSpacing: '2px' },
  modalOverlay: { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1000 },
  modal: { background: 'white', borderRadius: '16px', padding: '30px', width: '450px', boxShadow: '0 10px 40px rgba(0,0,0,0.3)' },
  modalTitle: { color: '#2e7d32', marginBottom: '20px', fontSize: '18px', borderBottom: '2px solid #e8f5e9', paddingBottom: '10px' },
  secretCodeBox: { background: 'linear-gradient(135deg, #1a237e, #0d47a1)', borderRadius: '12px', padding: '25px', textAlign: 'center', marginBottom: '20px' },
  secretCodeLabel: { color: 'rgba(255,255,255,0.8)', fontSize: '14px', marginBottom: '10px' },
  secretCode: { fontSize: '36px', fontWeight: 'bold', color: 'white', letterSpacing: '5px', background: 'rgba(255,255,255,0.1)', padding: '15px', borderRadius: '10px', margin: '10px 0' },
  secretCodeNote: { color: '#ffd54f', fontSize: '13px' },
  modalDetails: { background: '#f8f9fa', borderRadius: '10px', padding: '15px', marginBottom: '20px' },
  modalRow: { display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #e0e0e0' },
  modalLabel: { color: '#666', fontSize: '13px' },
  modalValue: { color: '#1a237e', fontWeight: 'bold', fontSize: '13px' },
  modalButtons: { display: 'flex', gap: '10px' },
  printCodeBtn: { flex: 1, background: 'linear-gradient(135deg, #1a237e, #0d47a1)', color: 'white', border: 'none', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px', fontWeight: 'bold' },
  closeBtn: { flex: 1, background: '#f5f5f5', color: '#666', border: '1px solid #e0e0e0', padding: '12px', borderRadius: '8px', cursor: 'pointer', fontSize: '14px' },
};

export default Transfers;